<template>
    <li class="list-group-item" :class="detalle ? 'lightgray2-content' : ''">
        <div class="row">
            <div class="col-12 d-flex justify-content-between" @click="detalle = !detalle">
                <span>
                    <b>{{ pedido.evento.name }}</b>
                    <span v-if="pedido.sesion"> | <b>{{ pedido.sesion.fecha }}</b></span> |
                    <b> {{ $t('perfil.n_pedido') }}: {{ pedido.id }}</b>
                    | <b>{{ $t('perfil.entradas') }}: {{ pedido.units }}</b>
                </span>
                <span>
                    <i :class="detalle ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                </span>
            </div>
            <transition name="fade" mode="out-in">
                <div class="col-12" v-if="detalle">
                    <div class="row pt-3">
                        <div v-if="pedido.puede_descargar_entradas" class="col-12 d-flex justify-content-center mb-4">
                            <a v-if="!anuladas" class="button" :href="pedido.url_pdf" target="_blank">{{ $t('perfil.descargar_todas') }}</a>
                            <button v-if="!anuladas" @click="enviarEntradas()" class="button ml-2">{{ $t('perfil.enviar_entradas') }}</button>
                        </div>
                        <div class="col-12">
                            <div class="row pr-md-4 pl-md-4">
                                <template v-for="(entrada, index) in pedido.entradas">
                                    <div class="col-12 d-flex justify-content-between" :key="entrada.id">
                                        <ul class="list-group pb-4" style="width: 100%">
                                            <li class="list-group-item">{{ $t('perfil.entrada') }} N°: <b>{{++index}}</b></li>
                                            <li v-if="pedido.puede_descargar_entradas" class="list-group-item">{{ $t('perfil.qr_code') }}: <b>{{ entrada.qr_code }}</b></li>
                                            <li class="list-group-item">
                                                {{ $t('formularios.dni') }}: <b>{{ entrada.user_dni }}</b>
                                                <CambiarDatos v-if="entrada.puede_cambiar_datos && !entrada.deleted_at" :entrada="entrada" :esMovil="esMovil" :left="'14.8em'" :top="'0.5em'" @close="closeModal" @show="showModal"/>
                                            </li>
                                            <li class="list-group-item">
                                                {{ $t('formularios.nombre') }}: <b>{{ entrada.user_nombre }} {{ entrada.user_apellidos }}</b>
                                                <CambiarDatos v-if="entrada.puede_cambiar_datos && !entrada.deleted_at" :entrada="entrada" :esMovil="esMovil" :left="'24.85em'" :top="'0.55em'" @close="closeModal" @show="showModal"/>
                                            </li>
                                            <li class="list-group-item">
                                                <ul class="list-group" style="list-style:none;">
                                                    <li>{{ $t('perfil.enviado') }}: {{ entrada.enviado ? $t('perfil.si_enviado') : $t('perfil.no_enviado') }}</li>
                                                    <li v-if="entrada.enviado && entrada.enviado.email">Email: {{entrada.enviado.email}}</li>
                                                    <li v-if="entrada.enviado && entrada.enviado.telefono">{{ $t('perfil.telefono') }}: {{entrada.enviado.telefono}}</li>
                                                    <li v-if="entrada.enviado">{{ $t('perfil.fecha') }}: {{entrada.enviado.fecha}}</li>
                                                </ul>
                                            </li>
                                            <li class="list-group-item">{{ $t('perfil.ANULADA') }}: {{entrada.deleted_at ? 'SI' : 'NO'}}</li>
                                            <li class="list-group-item" v-if="!entrada.deleted_at && (pedido.date_caducidad || entrada.date_caducidad && entrada.deleted_at)">
                                                <ul class="list-group" style="list-style:none;">
                                                    <li>{{ $t('perfil.caducara') }}: {{!entrada.download_date  ? 'SI' : 'NO'}}</li>
                                                    <li v-if="!entrada.download_date">{{ $t('perfil.fecha') }}: {{pedido.date_caducidad ? pedido.fecha_caducidad : entrada.fecha_caducidad }}</li>
                                                </ul>
                                            </li>
                                            <template v-if="entrada.asiento">
                                                <li class="list-group-item">
                                                    {{ $t('perfil.zona') }}: <b>{{ entrada.asiento.zona }}</b>
                                                </li>
                                                <li class="list-group-item">
                                                    {{ $t('perfil.fila') }}: <b>{{ entrada.asiento.fila }}</b>
                                                </li>
                                                <li class="list-group-item">
                                                    {{ $t('perfil.asiento') }}: <b>{{ entrada.asiento.asiento }}</b>
                                                </li>
                                            </template>
                                            <li class="list-group-item p-3 d-flex justify-content-between" v-if="entrada.deleted_at == null && pedido.puede_descargar_entradas">
                                                <a class="button" :href="entrada.url_pdf" target="_blank">{{ $t('perfil.descargar') }}</a>
                                                <button @click="showModal('send-' + entrada.id)" class="button ml-3">{{ $t('perfil.enviar_entrada') }}</button>
                                            </li>
                                            <li class="list-group-item p-3 d-flex justify-content-between" v-else>
                                                <h4>Las entradas serán enviadas por correo electrónico 72 horas antes del evento.</h4>
                                            </li>
                                            <SendTicketModal :id="entrada.id" :order_id="pedido.id" :qr_codes="[entrada.qr_code]" :entradas_id="[entrada.id]" @close="closeModal"/>                                            
                                        </ul>                                   
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div v-if="pedido.productos" class="col-12 col-md-11 m-auto">
                            <h5 class="mb-3">{{ $t('perfil.productos') }}</h5>
                            <div class="row">
                                <div class="col-12 pr-md-2 pl-md-2" v-for="(producto) in pedido.productos" :key="producto.id">
                                    <div class="card mb-3">
                                        <div class="card-body d-flex align-items-center">
                                            <img v-if="producto.image" :src="producto.image" alt="Imagen del producto" class="img-thumbnail mr-3" style="width: 100px; height: auto;"/>
                                            <div>
                                                <h6 class="card-title mb-1">{{ producto.name }}</h6>
                                                <p class="mb-1">{{ $t('perfil.producto_descripcion') }}: <b>{{ producto.description }}</b></p>
                                                <p class="mb-0">{{ $t('perfil.producto_unidades') }}: <b>{{ producto.units }}</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                            
            </transition>
        </div>
    </li>
</template>

<script>
    import { config } from '@/config.js';
    import SendTicketModal from './SendTicketModal.vue';
    import CambiarDatos from './CambiarDatos.vue';

    export default {
        props: ['pedido', 'esMovil'],
        data() {
            return {
                detalle: false,
                config: config
            }
        },
        computed: {
            anuladas() {
                var countAnuladas = this.pedido.entradas.filter(entrada => entrada.deleted_at != null).length;
                var countEntradas = this.pedido.entradas.length;

                if (countAnuladas == countEntradas) {
                    return true;
                } else {
                    return false;
                }

            },
        },
        methods: {
            enviarEntradas() {
                this.$emit('enviar', this.pedido);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        components: {
            SendTicketModal, CambiarDatos
        }
    }
</script>
